<kendo-dialog title="Important Information" (close)="closeMaintenanceDialog()" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center">The Site will be in maintenance from {{dateInfo.activeFrom | date:
        defaultfilterFullDatetimeFormatGMT}} until {{dateInfo.activeUntil | date:
        defaultfilterFullDatetimeFormatGMT}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="closeMaintenanceDialog()" class="ml-3 btn btn-primary">
            Accept
        </button>
    </kendo-dialog-actions>
</kendo-dialog>